/* eslint-disable no-param-reassign */
import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

const initialPunchoutState = {
    isPhoneNumberValid: false,
};

const slice = createSlice({
    name: 'punchout',
    initialState: initialPunchoutState,
    reducers: {
        setPhoneNumberValid: (state, action: PayloadAction<boolean>) => {
            state.isPhoneNumberValid = action.payload;
        },
    },
});

export const { actions: punchoutActions, reducer: punchoutReducer } = slice;
